module.exports = __webpack_public_path__ + "images/emoji/wc.49257ddb6c823f5467d5.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/wc.png
// module id = 37EC
// module chunks = 2